module.exports = __webpack_public_path__ + "img/3-4.6f54f886.svg";